import "./ContactUsForm.css";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";

function ContactUsForm() {
  const { t } = useTranslation("contact");

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    emailjs
      .send("service_wbfy4ar", "template_97o3gzb", data, "Ioq784HB42tXkN7IV")
      .then(
        () => {
          alert("Message sent successfully ✅");
          reset();
        },
        (error) => {
          console.error(error);
          alert("Failed to send ❌");
        },
      );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
      <h3>{t("contactUsForm.formTopic")}</h3>
      <div className="d-flex flex-column gap-2">
        <label htmlFor="">{t("contactUsForm.nameLabel")}</label>
        <input type="text" {...register("fullName", { required: true })} />
        {errors.fullName && <p className="small">Name is required</p>}
      </div>
      <div className="d-flex flex-column gap-2">
        <label htmlFor="">{t("contactUsForm.phoneLabel")}</label>
        <input type="text" {...register("phone", { required: true })} />
        {errors.phone && <p className="small">Phone is required</p>}
      </div>
      <div className="d-flex flex-column gap-2">
        <label htmlFor="">{t("contactUsForm.emailLabel")}</label>
        <input type="email" {...register("email", { required: true })} />
        {errors.email && <p className="small">Email is required</p>}
      </div>
      <div className="d-flex flex-column gap-2">
        <label htmlFor="">{t("contactUsForm.messageLabel")}</label>
        <textarea {...register("message", { required: true })} />
        {errors.message && <p className="small">Message is required</p>}
      </div>

      <button type="submit">Send Message</button>
    </form>
  );
}

export default ContactUsForm;
